// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const EncryptionPage = lazy(() => import('./pages/EncryptionPage'));
const SsoSamlPage = lazy(() => import('./pages/SsoSamlPage'));
const IpAllowlistPage = lazy(() => import('./pages/IpAllowlistPage'));
const FieldAuditTrailPage = lazy(() => import('./pages/FieldAuditTrailPage'));
const DataResidencyPage = lazy(() => import('./pages/DataResidencyPage'));
const ComplianceCenterPage = lazy(() => import('./pages/ComplianceCenterPage'));
const DataMaskingPage = lazy(() => import('./pages/DataMaskingPage'));

export const SecurityRoutes: RouteObject = {
  path: 'security',
  element: <ModuleGuard moduleId="core.security" />,
  children: [
    { path: 'encryption', element: <EncryptionPage />, handle: { crumb: 'Encryption' } },
    { path: 'sso-saml', element: <SsoSamlPage />, handle: { crumb: 'SSO & SAML' } },
    { path: 'ip-allowlist', element: <IpAllowlistPage />, handle: { crumb: 'IP Allowlist' } },
    { path: 'field-audit-trail', element: <FieldAuditTrailPage />, handle: { crumb: 'Field Audit Trail' } },
    { path: 'data-residency', element: <DataResidencyPage />, handle: { crumb: 'Data Residency' } },
    { path: 'compliance-center', element: <ComplianceCenterPage />, handle: { crumb: 'Compliance Center' } },
    { path: 'data-masking', element: <DataMaskingPage />, handle: { crumb: 'Data Masking' } },
  ],
};
